<mat-card>
  <mat-card-header *ngIf="!widget.meta.hideTitle">
    <mat-card-title
      *ngIf="!changeTitle; else editTitleWidget"
      [matTooltip]="'dashboard.operational.widgets.doubleClickToEditTitle' | t"
      matTooltipPosition="above"
      (dblclick)="editTitle()"
      class="editTitle"
      >{{ widget.name }}
      <sn-icon size="xs">edit</sn-icon>
    </mat-card-title>
    <button
      mat-icon-button
      *ngIf="canChange && channel && !changeTitle"
      color="accent"
      [matTooltip]="'dashboard.operational.widgets.changeSelectedChatChannel' | t"
      matTooltipPosition="above"
      (click)="selectChannel()"
    >
      <mat-icon>swap_horizontal_circle</mat-icon>
    </button>
    <button
      mat-icon-button
      *ngIf="channel"
      [class.active]="showMembers"
      class="showMembers"
      (click)="showMembers = !showMembers"
    >
      <sn-icon>people</sn-icon>
    </button>
  </mat-card-header>
  <mat-card-content [class.member-list]="channel && showMembers">
    <ng-container *ngIf="!channel">
      <sn-empty-state>
        <button mat-button [disabled]="!canSelect" (click)="selectChannel()">
          {{ 'dashboard.operational.widgets.selectChatChannel' | t }}
        </button>
      </sn-empty-state>
    </ng-container>
    <ng-container *ngIf="channel">
      <sn-chat-channel
        [ngStyle]="{ display: !showMembers ? 'flex' : 'none' }"
        #chatChannel
        [channel]="channel"
        [userHasAccess]="userHasAccess"
      ></sn-chat-channel>
      <sn-channel-members-list
        *ngIf="channel.sid && showMembers"
        [sid]="channel.sid"
        (reloadChat)="reloadChat($event)"
      ></sn-channel-members-list>
    </ng-container>
  </mat-card-content>
</mat-card>
<ng-template #editTitleWidget>
  <sn-form-edit-title
    [widget]="widget"
    [viewId]="viewId"
    (title)="setTitle($event)"
    (updateTitle)="setUpdateTitle($event)"
  ></sn-form-edit-title>
</ng-template>
